import { useContext, useEffect } from "react";
import RelifeContactNew from "./homeLayout/RelifeContactNew";
import "./style/BillingRefunds.css";
import { useLocation, useNavigate } from "react-router-dom";
import { AuthContext } from "./auth/AuthProvider";

export default function BillingRefunds() {
  const { user, googleUser } = useContext(AuthContext);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // localStorage.setItem("postLoginRedirectTheme", prevLocation);

    if (!user && !googleUser) {
      // localStorage.setItem("postLoginRedirectTheme", prevLocation);
      localStorage.setItem("postLoginRedirect", location.pathname);
      // return;
    }
  }, [user, googleUser, navigate]);
  return (
    <>
      <section className="billing-page">
        <div className="billing-card">
          <h1 className="billing-title">Billing &amp; Refunds</h1>

          <div className="billing-section">
            <h2 className="billing-heading">Pricing Model</h2>
            <p>
              Introspecta operates on a simple, transparent one-time payment
              model. Each theme is priced at €14.99, which provides permanent
              access to all 5 phases and 25 audio-guided sessions within that
              specific theme.
            </p>
            <p>There are no recurring subscriptions or hidden fees.</p>
          </div>

          <div className="billing-section">
            <h2 className="billing-heading">Refund Policy</h2>
            <p>
              We want you to feel comfortable with your journey. If a theme does
              not resonate with you, you may request a refund within 14 days
              from the date of purchase, provided that you have not started
              Phase 2 of that theme.
            </p>
            <p>
              Once the first question of Phase 2 has been opened, the purchase
              becomes non-refundable due to the nature of digital content and
              immediate access to the full guided experience.
            </p>
            <p>
              Refund requests are reviewed based on the access and progress
              recorded in your account.
            </p>
          </div>

          <div className="billing-section">
            <h2 className="billing-heading">Billing Support</h2>
            <p>
              If you have any questions regarding your purchase, payment
              methods, or wish to request a refund, please contact our billing
              team at:
            </p>

            <a
              className="billing-email"
              href="https://mail.google.com/mail/?view=cm&fs=1&to=billing@introspecta.app"
              target="_blank"
              rel="noreferrer"
            >
              billing@introspecta.app
            </a>

            <p className="billing-sub">
              We typically respond to billing inquiries within 24–48 hours.
            </p>
          </div>
        </div>
      </section>

      <RelifeContactNew />
    </>
  );
}
